import axios from "axios";
const urlProd = "https://opto-prod-623312051977.us-east1.run.app";
const urlLocal = "http://localhost:9090/";
const urlStagging =
  "https://opto-stagging-623312051977.us-east1.run.app";

const url = window.location.hostname;
const isLocal = url === "localhost" || url === "127.0.0.1";
const isStagging =
  url === "opto-stagging-test.web.app" ||
  url === "optotools-stagging-623312051977.us-east1.run.app";

export default axios.create({
  baseURL:
    isLocal
      ? urlLocal
      : isStagging
        ? urlStagging
        : urlProd,
});
